import axios from 'axios';
import config from '../config';

const { API_ENDPOINT } = config;
const api = ({
  login: (Username, Password, ApiKey) => {
    const data = { Username, Password };
    const loginUrl = API_ENDPOINT + 'api/internal/users/getAccessToken';
    return axios({ method: 'POST', url: loginUrl, headers: {
      'ApiKey': `${ApiKey}`
    }, data, timeout: 600000 });
  },
  tireSet: {
    post: stage => data => {
      return axios.post(API_ENDPOINT + 'api/tireSet/' + stage, data);
    },
    get: (registerNumber, officeId) => {
      return axios.get(API_ENDPOINT + 'api/tireSet/' + registerNumber + '?officeId=' + officeId);
    }
  },
  valueList: {
    get: valueListKey => {
      return axios.get(API_ENDPOINT + 'api/valueLists/' + valueListKey);
    }
  }
});
export default api;